import { handleValidationChange } from "../CommonValidation";

export const validateUsers = (data, setIsError, type) => {
    console.log(type)
    var isValid = true;
    var isValidFirstName = true;
    var isValidLastName = true;
    var isValidUsername = true;
    var isValidPassword = true;
    var isValidType = true;
    var isValidConfirmPassword = true;
    var isValidTerminal = true;
    var isValidBranch = true;

    if (data.first_name === "" || data.first_name === undefined) {
        handleValidationChange("first_name", true, setIsError);
        isValidFirstName = false;
    } else {
        handleValidationChange("first_name", false, setIsError);
        isValidFirstName = true;
    }

    if (type !== "terminal" && (data.last_name === ""|| data.last_name === undefined)) {
        handleValidationChange("last_name", true, setIsError);
        isValidLastName = false;
    } else {
        handleValidationChange("last_name", false, setIsError);
        isValidLastName = true;
    }

    if (type === "terminal" && (data.terminal_id === ""|| data.terminal_id === undefined)) {
        handleValidationChange("terminal_id", true, setIsError);
        isValidTerminal = false;
    } else {
        handleValidationChange("terminal_id", false, setIsError);
        isValidTerminal = true;
    }

    if (type === "terminal" && (data.branch_id === ""|| data.branch_id === undefined)) {
        handleValidationChange("branch_id", true, setIsError);
        isValidBranch = false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
        isValidBranch = true;
    }

    if (data.type === ""|| data.type === undefined) {
        handleValidationChange("type", true, setIsError);
        isValidType = false;
    } else {
        handleValidationChange("type", false, setIsError);
        isValidType = true;
    }


    if (data.username === ""|| data.username === undefined) {
        handleValidationChange("username", true, setIsError);
        isValidUsername = false;
    } else {
        handleValidationChange("username", false, setIsError);
        isValidUsername = true;
    }

    if (data.confirm_password === ""|| data.confirm_password === undefined) {
        handleValidationChange("confirm_password", true, setIsError);
        isValidConfirmPassword = false;
    } else {
        handleValidationChange("confirm_password", false, setIsError);
        isValidConfirmPassword = true;
    }

    isValid =
        isValidFirstName &&
        isValidLastName &&
        isValidType &&
        isValidUsername &&
        isValidTerminal &&
        isValidBranch &&
        isValidPassword &&
        isValidConfirmPassword;

    return isValid;
};
